import { twMerge } from "tailwind-merge"

export type PageTitleProps = {
  title: string
  subtitle?: string
  children?: React.ReactNode
  className?: string
}

export function PageTitle(props: PageTitleProps) {
  const { title, subtitle, children, className } = props

  return (
    <hgroup className={twMerge("flex flex-col gap-2 px-6 py-8", className)}>
      <h1 className="font-souvenir text-3xl font-medium text-gray-900 md:text-4xl">{title}</h1>
      {subtitle && <p className="text-lg text-gray-500">{subtitle}</p>}
      {children}
    </hgroup>
  )
}
